<template>
  <main class="pricing" >
    <h1 id="pTop">Pricing</h1>

    <div id="container">

      <div class="spinerParent" v-if="loading">
        <img src="../assets/spinb.png" />
      </div>

      <fetchError :style="{display:fetchErr?'flex':'none', margin: 'auto'}" :Exception="fetchErr" />

      <div class="prevHeader" v-if="!loading && !fetchErr">

<!--         <select id="lang" v-if="!validating">
          <option value="en">English</option>
          <option value="es">Español</option>
        </select> -->

        <div class="customBtn" v-if="validating" @click="stopValidation()">
          <i class="icofont-plus-circle"></i>
          <p>New</p>
        </div>

        <div class="customBtn" @click="printInvoice()" ref="printBtn">
          <i v-if="!printing" class="icofont-print"></i>
          <p v-if="!printing">Print</p>
          <div class="spinerParent" v-if="printing">
            <img src="../assets/spinb.png" />
          </div>
        </div>

<!--         <div class="customBtn">
          <i class="icofont-letter"></i>
          <p>Send as email</p>
        </div> -->

      </div>

      <div class="pageView" v-if="!loading && !fetchErr" ref="view">
        {{ adjustScroll() }}
        <PricingPage :Details="invoice" />
      </div>
    </div>

  </main>
</template>

<script>
import queryPalette from "../mixins/themeColor.js";
import PricingPage from "../components/PricingPage.vue";

import Request from "../mixins/axiosRequest.js";
import fetchError from "../components/Small/fetchError.vue";

import { EventBus } from "../mixins/eventBus.js";

export default {
  name: "Pricing",
  title: "Pricing - Nethanzêl's Showroom",
  components: {
    PricingPage,
    fetchError
  },

  data() {
    return {
      loading: true,
      invoice: undefined,
      fetchErr: undefined,
      validating: false,
      printing: false,
      invoiceRequest: {
        tasks: [],
        desc: null,
        requester: null,
        company: null
      }
    }
  },

  methods: {
    meshApply() {
      queryPalette.generatePalette().then((Palette) => {
        document.querySelector("#container").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#container").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#container").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
      });
    },
    async createInvoice() {
      this.printing = true;
      let hasError = false;

      if(!(this.invoiceRequest.requester?.length > 3)) {
        EventBus.$emit("invalidRequester");
        hasError = true;
      }

      if(this.invoiceRequest.tasks.length == 0) {
        EventBus.$emit("invalidTask");
        hasError = true;
      }

      if(hasError) return this.printing = false;

      let data = await Request.axiosPost(`/api/invoice`, this.invoiceRequest, this.client);

      if(data.status && data.data.result) {
        let invoiceNumber = data.data.newInvoice.invoice;
        await this.getInvoice(invoiceNumber);
      }
      this.printing = false;
    },
    async printInvoice () {
      if(this.validating) {
        this.printing = true;
        await this.getInvoice(this.invoice.invoice);
        this.printing = false;
      } else {
        this.createInvoice()
      }
    },
    async getInvoice(number) {
      let data = await Request.axiosGet(`/api/invoice/print/${number}`, this.client);
        if(data.status) {
          this.$refs.printBtn.style.backgroundColor = "#00ff00ab"
          setTimeout(() => this.$refs.printBtn.style.backgroundColor = "#ffffffab", 5000);
          setTimeout(() => {
            let pdfWindow = window.open("");
            pdfWindow.document.write("<iframe width='100%' height='99%' src='data:application/pdf;base64, " + encodeURI(data.data) + "'></iframe>");
            pdfWindow.document.title = "Pricing - Nethanzêl's Showroom";
          }, 2500);
        } else {
          this.$refs.printBtn.style.backgroundColor = "#ff0000ab"
          setTimeout(() => this.$refs.printBtn.style.backgroundColor = "#ffffffab", 5000);
        }
    },
    stopValidation() {
      this.invoice = undefined;
      this.validating = false;
      EventBus.$emit("stopValidation");
      this.$router.push("/pricing")
    },
    adjustScroll () {
      setTimeout(() => {
        if(window.getComputedStyle(this.$refs.view).display == "flex") return;
        this.$refs.view.scrollTo({
          top: (this.$refs.view.scrollHeight / 2) - (this.$refs.view.offsetHeight / 2),
          left: (this.$refs.view.scrollWidth / 2) - (this.$refs.view.offsetWidth / 2),
          behavior: 'smooth'
        });
      }, 1000);
    }
  },
  async mounted() {
    this.meshApply();
    if(this.$route.params.invoice) {
      let data = await Request.axiosGet(`/api/invoice/${this.$route.params.invoice}`, this.client);
      if(data.status) {
        this.invoice = data.data;
        this.validating = true;
      } else {
        this.fetchErr = data.data;
      }
    }

    this.loading = false;

    EventBus.$on("tableTask", (task) => this.invoiceRequest.tasks.push(task));

    EventBus.$on("pageDescription", (description) => {
      if(description.length > 49) {
        this.invoiceRequest.desc = description
      } else this.invoiceRequest.desc = null;
    });

    EventBus.$on("inpRequester", (input) => this.invoiceRequest.requester = input);
    EventBus.$on("inpReceiver", (input) => this.invoiceRequest.company = input);
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  h1 {
    color: #fff;
  }
  h1::after {
    border-bottom: 2px solid #fff;
  }
  #container {
    background-color: #fff;
  }
  .customBtn{
    background-color: #ffffffab;
  }
}

@media (prefers-color-scheme: light) {
  h1 {
    color: #000;
  }
  h1::after {
    border-bottom: 2px solid #000;
  }
  #container {
    background-color: #d1d1d1;
  }
  .customBtn{
    background-color: #000000ab;
    
  }
}

h1 {
  letter-spacing: 3px;
  text-align: center;
  width: 100%;
  cursor: default;
  z-index: 10;
  margin-bottom: 45px;
  margin-top: 25px;
  transition: .4s;
}

h1::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 90px;
  margin-top: 10px;
  transition: .4s;
}

.pricing {
  display: flex;
  flex-direction: column;
  cursor: default;
  max-width: 1366px;
  margin: 0 auto 0 auto;
  padding-top: 60px;
  min-height: 70vh;
}

#container {
  transition: background-color .4s;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  z-index: 5;
  margin: 0 5px;
  padding:  5px 0 50px 0;
  min-height: 50vh;
  color: #000;

  .spinerParent {
    margin: auto;
  }
}

.customBtn {
  display: flex;
  align-items: center;
  margin: 0 10px;
  padding: 7px 10px;
  border-radius: 3px;
  cursor: pointer;
  transition: background-color .5s;

  p {
    font-size: 14.5px;
    cursor: pointer;
  }

  i {
    font-size: 23px;
    margin: 0 6px 0 0;
  }

  .spinerParent {
    img {
      height: 25px;
      width: 25px;
    }
  }
}

select {
  min-width: 140px;
  outline: none;
  padding-left: 10px;
}

select:hover {
  outline: none;
}

.prevHeader {
  display: flex;
  justify-content: flex-end;
  align-self: center;
  padding: 10px;
  margin: 10px 15px 10px 15px;
  width: 95%;
}

.pageView {
  background-color: #000000;
  min-height: 500px;
  max-height: 85vh;
  width: calc(100% - 50px);
  margin: 0 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

@media screen and (max-width: 940px) {
  .pageView {
    width: calc(100% - 20px);
    display: block;
  }

}

@media screen and (max-width: 780px) {

  h1 {
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 590px) {
  .pageView {
    width: calc(100% - 5px);
  }

}

@media screen and (max-width: 445px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 415px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 395px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    letter-spacing: 3px;
    font-size: 40px;
  }
}

</style>
